var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar fixed-bottom navbar-light"},[_c('span',{staticClass:"navbar-brand kkk mx-auto"},[_vm._v("RockArt")])])}]

export { render, staticRenderFns }